import { render, staticRenderFns } from "./JoinusModal.vue?vue&type=template&id=0583212e"
import script from "./JoinusModal.vue?vue&type=script&lang=ts"
export * from "./JoinusModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports